import React, {Component} from 'react';
import {connect} from 'react-redux';
import {find, sumBy, cloneDeep} from 'lodash';
import {Card, Table, Loader, Popup} from 'semantic-ui-react';
import {CARLOS_LARREA_RUC, HIDROBO_RUC} from '../../../common/constants/dealer';
import {dealerList, dealerListForVehiclesSummary,
  dealerListForVehiclesSummaryStock, dealerListForVehiclesSummarySales} from '../../../common/constants/lists';
import './dailyVehiclesSummary.scss';

const valueIfNull = '0';

class DataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'dealers': this.getDealersListToShow(props.dealerSelected),
      'dealersSales': this.getDealersListToShowSales(props.dealerSelected),
      'dealersForStock': this.getDealersListToShowInStock(props.dealerSelected),
    };
  }
  
  getDealersListToShowSales = (dealerSelected) => {
    let newList = [];
    if (dealerSelected === 'all') {
      newList = cloneDeep(dealerListForVehiclesSummarySales);
    } else {
      const dealerInfo = find(dealerList, {'value': dealerSelected});
      newList.push(dealerInfo);
      newList.push({'text': 'TASACIERRE', 'value': 'tasCierre', 'alias': 'TASA CIERRE'});
    }
    return newList;
  };
  getDealersListToShow = (dealerSelected) => {
    const newList = [];
    if (dealerSelected === 'all') {
      return dealerListForVehiclesSummary;
    }

    const dealerInfo = find(dealerList, {'value': dealerSelected});
    newList.push(dealerInfo);
    return newList;
  };

  getDealersListToShowInStock = (dealerSelected) => {
    let newList = [];

    if (dealerSelected === 'all') {
      newList = cloneDeep(dealerListForVehiclesSummaryStock);
    } else {
      const dealerInfo = find(dealerList, {'value': dealerSelected});
      newList.push(dealerInfo);
      newList.push({'text': 'TOTAL', 'value': 'total', 'alias': 'TOT'});
      newList.push({'text': 'MS', 'value': 'monthsStock', 'alias': 'MESES STOCK'});
    }
    newList.unshift({'text': 'en TDE', 'value': 'tde', 'alias': 'TDE'});
    newList.unshift({'text': 'en DP', 'value': 'DP', 'alias': 'DP'});
    return newList;
  };

  componentDidUpdate(prevProps) {
    const {dealerSelected} = this.props;
    if (prevProps.dealerSelected !== dealerSelected) {
      this.setState({
        'dealers': this.getDealersListToShow(dealerSelected),
        'dealersSales': this.getDealersListToShowSales(dealerSelected),
        'dealersForStock': this.getDealersListToShowInStock(dealerSelected),
      });
    }
  }

  renderName = (dealer) => {
    if (dealer.value === 'tde') {
      return (
        <Popup
          trigger={<div className='underline'>{dealer.alias}</div>}
          on='click'
          position='bottom left'
          inverted
        >
          <div>
            Stock reservado por concesionario. Sin el filtro total stock TDE.
          </div>
        </Popup>
      );
    }
    return <div>{dealer.alias}</div>;
  };

  renderHeaderByDealers = (list) => {
    return list.map((dealer, index) => {
      return (
        <Table.HeaderCell
          key={index}
          className='lightgray-bg second-row-of-header'
        >
          {this.renderName(dealer)}
        </Table.HeaderCell>
      );
    });
  };

  getTotalByModel = (data) => {
    return Object.values(data).reduce((accum, item) => accum + item, 0);
  }

  getTotalAllModelsByDealer(type) {
    const {salesAndStockList} = this.props;
    const totalsValuesByDealers = {};

    salesAndStockList.forEach((item, index) => {
      const dataByDealers = item[type];

      Object.keys(dataByDealers).forEach((key) => {
        const value = dataByDealers[key];

        if (totalsValuesByDealers.hasOwnProperty(key)) {
          const oldValue = totalsValuesByDealers[key];
          totalsValuesByDealers[key] = oldValue + value;
          return;
        }
        totalsValuesByDealers[key] = value;
      });
    });

    return totalsValuesByDealers;
  }

  renderTotalsValuesByDealer = (
    list,
    type,
    totalTdeReservedStock = 0,
    totalDepositTransit = 0,
    monthsStock = '',
  ) => {
    const totalsValuesByDealers = this.getTotalAllModelsByDealer(type);
    const {salesAndStockList} = this.props;
    const salesLastMonth = Math.round(sumBy(salesAndStockList, 'salesLastMonth'));
    return list.map((dealer, index) => {
      if (dealer.value === 'sub') {
        const stockCarlosLarrea = totalsValuesByDealers[CARLOS_LARREA_RUC];
        const stockHidrobo = totalsValuesByDealers[HIDROBO_RUC];
        const stockSubDealer = stockCarlosLarrea + stockHidrobo;
        return (
          <Table.HeaderCell key={index} className='lightgray-bg'>
            {stockSubDealer}
          </Table.HeaderCell>
        );
      } else if (dealer.value === 'total') {
        const totalByDealer = this.getTotalByModel(totalsValuesByDealers);
        const total = totalByDealer + totalTdeReservedStock + totalDepositTransit;
        return (
          <Table.HeaderCell key={index} className='lightgray-bg'>
            {total}
          </Table.HeaderCell>
        );
      } else if (dealer.value === 'monthsStock') {
        return (
          <Table.HeaderCell key={index} className='lightgray-bg'>
            {salesLastMonth > 0 ?
              ((this.getTotalByModel(totalsValuesByDealers) + totalTdeReservedStock +
              totalDepositTransit) / salesLastMonth).toFixed(2) : 0}
          </Table.HeaderCell>
        );
      } else if (dealer.value === 'DP' && type === 'dealerStock') {
        return (
          <Table.HeaderCell key={index} className='lightgray-bg'>
            {totalDepositTransit}
          </Table.HeaderCell>
        );
      } else if (dealer.value === 'tde' && type === 'dealerStock') {
        return (
          <Table.HeaderCell key={index} className='lightgray-bg'>
            {totalTdeReservedStock}
          </Table.HeaderCell>
        );
      }
      return (
        <Table.HeaderCell key={index} className='lightgray-bg'>
          {totalsValuesByDealers[dealer.value]}
        </Table.HeaderCell>
      );
    });
  };

  renderTotalStockByDealer(type) {
    const {dealersForStock} = this.state;
    const {salesAndStockList} = this.props;
    const totalTdeReservedStock = sumBy(salesAndStockList, 'tdeReservedStock');
    const totalDepositTransit = sumBy(salesAndStockList, 'depositTransit');
    return this.renderTotalsValuesByDealer(dealersForStock, type, totalTdeReservedStock, totalDepositTransit);
  }

  renderTotalsByDealer(type) {
    const {dealers} = this.state;
    return this.renderTotalsValuesByDealer(dealers, type);
  }

  renderTotals = () => {
    const {loading, salesAndStockList} = this.props;
    const totalBudgetJapan = sumBy(salesAndStockList, 'objectiveJapan');
    const totalNewContractTasa = ((Array.isArray(salesAndStockList) && salesAndStockList.length > 0 &&
    salesAndStockList[0].totalNewContractTasa) ? salesAndStockList[0].totalNewContractTasa : 0) * 100;
    const totalSalesTasa = ((Array.isArray(salesAndStockList) && salesAndStockList.length > 0 &&
    salesAndStockList[0].totalSalesTasa) ? salesAndStockList[0].totalSalesTasa : 0) * 100;
    const {dealerSelected} = this.props;
    if (loading) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell className='lightgray-bg static-column'>
            TOTAL
          </Table.HeaderCell>
          {this.renderTotalStockByDealer('dealerStock')}
          {this.renderTotalsByDealer('vehicleReserve')}
          {this.renderTotalsByDealer('vehicleQuotation')}
          {this.renderTotalsByDealer('newContract')}
          { dealerSelected === 'all' ? <Table.HeaderCell className='lightgray-bg'>
            {Math.round(totalNewContractTasa)}</Table.HeaderCell> :
            <Table.HeaderCell className='lightgray-bg'> </Table.HeaderCell>}
          {this.renderTotalsByDealer('vehicleSales')}
          
          { dealerSelected === 'all' ? <Table.HeaderCell className='lightgray-bg'>
            {Math.round(totalSalesTasa)}</Table.HeaderCell> : <Table.HeaderCell className='lightgray-bg'>
          </Table.HeaderCell>}
          {this.renderTotalsByDealer('budgetList')}
          <Table.HeaderCell className='lightgray-bg'>
            {totalBudgetJapan}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderSingleValuesByDealer = (type, data, tdeReservedStock = 0, depositTransit = 0, monthsStock = 0) => {
    const list = type === 'stock' ? this.state.dealersForStock : this.state.dealers;
    return list.map((dealer, index) => {
      if (dealer.value === 'sub') {
        const stockCarlosLarrea = data[CARLOS_LARREA_RUC];
        const stockHidrobo = data[HIDROBO_RUC];
        const stockSubDealer = stockCarlosLarrea + stockHidrobo;

        return <Table.Cell key={index}>{stockSubDealer}</Table.Cell>;
      } else if (dealer.value === 'DP' && type === 'stock') {
        return <Table.Cell key={index}>{depositTransit}</Table.Cell>;
      } else if (dealer.value === 'tde' && type === 'stock') {
        return <Table.Cell key={index}>{tdeReservedStock}</Table.Cell>;
      } else if (dealer.value === 'total') {
        const totalByDealer = this.getTotalByModel(data);
        const total = totalByDealer + tdeReservedStock + depositTransit;

        return <Table.Cell key={index} className='lightgray-bg'>{total}</Table.Cell>;
      } else if (dealer.value === 'monthsStock' && type === 'stock') {
        return <Table.Cell key={index} className='lightgray-bg'>{monthsStock}</Table.Cell>;
      }
      return <Table.Cell key={index}>{data[dealer.value]}</Table.Cell>;
    });
  };

  /* eslint-disable max-statements */
  renderSingleValuesByDealerSales = (type, data, tdeReservedStock = 0, monthsStock = 0, totalQuotation = 0) => {
    const list = this.state.dealersSales;
    return list.map((dealer, index) => {
      if (dealer.value === 'sub') {
        const stockCarlosLarrea = data[CARLOS_LARREA_RUC];
        const stockHidrobo = data[HIDROBO_RUC];
        const stockSubDealer = stockCarlosLarrea + stockHidrobo;
        return <Table.Cell key={index}>{stockSubDealer}</Table.Cell>;
      } else if (dealer.value === 'tde' && type === 'stock') {
        return <Table.Cell key={index}>{tdeReservedStock}</Table.Cell>;
      } else if (dealer.value === 'total') {
        const totalByDealer = this.getTotalByModel(data);
        const total = totalByDealer + tdeReservedStock;
        return <Table.Cell key={index} className='lightgray-bg'>{total}</Table.Cell>;
      } else if (dealer.value === 'monthsStock' && type === 'stock') {
        return <Table.Cell key={index} className='lightgray-bg'>{monthsStock}</Table.Cell>;
      } else if (dealer.value === 'tasCierre') {
        const totalByDealer = this.getTotalByModel(data);
        const total = totalByDealer + tdeReservedStock;
        if (totalQuotation > 0) {
          const tasaTotal = Math.round(total / totalQuotation * 100);
          return <Table.Cell key={index} className='lightgray-bg'>{tasaTotal.toFixed(0)}%</Table.Cell>;
        }
        return <Table.Cell key={index} className='lightgray-bg'>{0}%</Table.Cell>;
      }
      return <Table.Cell key={index}>{data[dealer.value]}</Table.Cell>;
    });
  };


  renderStockByDealer = (data, tdeReservedStock, depositTransit, monthsStock) => {
    return this.renderSingleValuesByDealer('stock', data, tdeReservedStock, depositTransit, monthsStock);
  };

  renderValuesByDealer(data) {
    return this.renderSingleValuesByDealer('value', data);
  }

  renderValuesByDealerSales(data, totalQuotation = 0) {
    return this.renderSingleValuesByDealerSales('value', data, 0, 0, totalQuotation);
  }

  renderTableInformation = () => {
    const {salesAndStockList} = this.props;
    return salesAndStockList.map((record, index) => {
      return (
        <Table.Row textAlign='center' key={index}>
          <Table.Cell collapsing className='lightgray-bg static-column'>
            {record.vehicleModelName}
          </Table.Cell>
          {this.renderStockByDealer(record.dealerStock, record.tdeReservedStock, record.depositTransit,
            record.monthsStock)}
          {this.renderValuesByDealer(record.vehicleReserve)}
          {this.renderValuesByDealer(record.vehicleQuotation)}
          {this.renderValuesByDealerSales(record.newContract, record.totalQuotation)}
          {this.renderValuesByDealerSales(record.vehicleSales, record.totalQuotation)}
          {this.renderValuesByDealer(record.budgetList)}
          <Table.Cell>{record.objectiveJapan || valueIfNull}</Table.Cell>
        </Table.Row>
      );
    });
  };

  renderLoaderOrSales = () => {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderTableInformation();
  };

  render() {
    const {dealers, dealersForStock, dealersSales} = this.state;
    const {loading} = this.props;
    const dealersListToShowInStock = this.renderHeaderByDealers(dealersForStock);
    const dealersListToShow = this.renderHeaderByDealers(dealers);
    const dealersListToShowSales = this.renderHeaderByDealers(dealersSales);
    return (
      <Card raised fluid>
        <div className={`table-sticky-header-and-first-column ${loading ? 'searching' : ''}`}>
          <Table className='gray-table'>
            <Table.Header>
              <Table.Row textAlign='center'>
                <Table.HeaderCell className='lightgray-bg static-column' rowSpan='2'>Modelos</Table.HeaderCell>
                <Table.HeaderCell className='lightgray-bg' colSpan={dealersForStock.length}>Stock</Table.HeaderCell>
                <Table.HeaderCell className='lightgray-bg' colSpan={dealers.length}>Reservas</Table.HeaderCell>
                <Table.HeaderCell className='lightgray-bg' colSpan={dealers.length}>Tráfico</Table.HeaderCell>
                <Table.HeaderCell className='lightgray-bg' colSpan={dealersSales.length}>New Contract</Table.HeaderCell>
                <Table.HeaderCell className='lightgray-bg' colSpan={dealersSales.length}>Ventas</Table.HeaderCell>
                <Table.HeaderCell className='lightgray-bg' colSpan={dealers.length}>Objetivo Concesionario

                </Table.HeaderCell>
                <Table.HeaderCell className='lightgray-bg' rowSpan='2'>Objetivo Japón</Table.HeaderCell>
              </Table.Row>
              <Table.Row textAlign='center'>
                {dealersListToShowInStock}
                {dealersListToShow}
                {dealersListToShow}
                {dealersListToShowSales}
                {dealersListToShowSales}
                {dealersListToShow}
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {this.renderLoaderOrSales()}
            </Table.Body>

            {this.renderTotals()}
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.dailyVehiclesSalesAndStockSummary.loading,
    'salesAndStockList': state.dailyVehiclesSalesAndStockSummary.salesAndStockList,
  };
};

export default connect(mapStateToProps, {
})(DataTable);
